import moment from 'moment'
import getProp from '@f/get-prop'

export const getAPIUsage = (state, workspaceSlug) =>
  getProp(`legacyAPIUsage.${workspaceSlug}`, state)

export const getAPIUsageBySourceIDForCurrentPeriod = (state, workspaceSlug, sourceId) => {
  const usage = getAPIUsage(state, workspaceSlug) || {}
  const { periodStart, periodEnd, breakdown } = getProp(`data.integrations.0`, usage) || {}

  // Ensure `period` is the current period
  if (!periodStart || moment(periodStart).isBefore(moment().subtract(1, 'month'))) return

  return {
    periodStart,
    periodEnd,
    ...breakdown[sourceId]
  }
}



// WEBPACK FOOTER //
// ./selectors/legacy-api-usage.js